import HTTP from "@/plugins/http";
import utils from "@/resources/utils";
import validationStatusCode from "@/resources/validation_status_code";

const getProvidersWithoutPagination = async token =>
  validationStatusCode(
    await HTTP.get(`/providers/list_without_pagination`, {
      headers: utils.headerAuth(token)
    })
  );

const getProviders = async (token, page) =>
  validationStatusCode(
    await HTTP.get(`/providers/?page=${page}`, {
      headers: utils.headerAuth(token)
    })
  );

const getProvider = async (id, token) =>
  validationStatusCode(
    await HTTP.get(`/providers/${id}`, {
      headers: utils.headerAuth(token)
    })
  );

const createProvider = async (provider, token) =>
  validationStatusCode(
    await HTTP.post("/providers/", provider, {
      headers: utils.headerAuth(token)
    })
  );

const updateProvider = async (id, provider, token) => {
  return validationStatusCode(
    await HTTP.patch(`/providers/${id}/`, provider, {
      headers: utils.headerAuth(token)
    })
  );
};

const deleteProvider = async (id, token) =>
  validationStatusCode(
    await HTTP.delete(`/providers/${id}/`, {
      headers: utils.headerAuth(token)
    })
  );

export default {
  getProvidersWithoutPagination,
  getProviders,
  getProvider,
  createProvider,
  updateProvider,
  deleteProvider
};
